import 'svelte/internal/disclose-version';

ReviewSession[$.FILENAME] = 'src/ui/ReviewSession.svelte';

import * as $ from 'svelte/internal/client';
import Flashcard from "./Flashcard.svelte";
import SessionSummary from "./SessionSummary.svelte";
import { Press, watchAlt } from "./keys.ts";

import {
	KIND_TEXT,
	backText,
	canResume,
	locked,
	phase,
	saveView,
	segments,
	shownResult,
	summary,
	tally
} from "./session.ts";

var root = $.add_locations(
	$.from_html(
		`
        <!>
      `,
		1
	),
	ReviewSession[$.FILENAME],
	[]
);

var root_1 = $.add_locations(
	$.from_html(
		`
              <li class="svelte-1ivqid2jrt9dg">
                <span class="prompt svelte-1ivqid2jrt9dg" lang="zh-Hans"> </span>
                <span class="kind svelte-1ivqid2jrt9dg"> </span>
                <span class="when svelte-1ivqid2jrt9dg"> </span>
              </li>
            `,
		1
	),
	ReviewSession[$.FILENAME],
	[[131, 14, [[132, 16], [133, 16], [134, 16]]]]
);

var root_2 = $.add_locations($.from_html(`<kbd>Enter</kbd>`), ReviewSession[$.FILENAME], [[146, 23]]);

var root_3 = $.add_locations(
	$.from_html(
		`
        <section class="waiting svelte-1ivqid2jrt9dg" aria-labelledby="waiting-title">
          <h2 id="waiting-title" class="svelte-1ivqid2jrt9dg"> </h2>
          <p class="note svelte-1ivqid2jrt9dg">Nothing else is due. Missed cards come back once their step has passed.</p>
          <ul class="coming svelte-1ivqid2jrt9dg">
            <!>
          </ul>
          <button type="button">
            Continue
            <!>
          </button>
        </section>
      `,
		1
	),
	ReviewSession[$.FILENAME],
	[[124, 8, [[125, 10], [128, 10], [129, 10], [138, 10]]]]
);

var root_4 = $.add_locations(
	$.from_html(
		`
          <span></span>
        `,
		1
	),
	ReviewSession[$.FILENAME],
	[[154, 10]]
);

var root_5 = $.add_locations($.from_html(`<span> </span>`), ReviewSession[$.FILENAME], [[160, 33]]);
var root_6 = $.add_locations($.from_html(`<span class="new svelte-1ivqid2jrt9dg">new card</span>`), ReviewSession[$.FILENAME], [[161, 57]]);
var root_7 = $.add_locations($.from_html(`<kbd>Alt E</kbd>`), ReviewSession[$.FILENAME], [[171, 19]]);

var root_8 = $.add_locations(
	$.from_html(
		`
    <div class="stage svelte-1ivqid2jrt9dg">
      <!>
    </div>
    <div class="bar svelte-1ivqid2jrt9dg">
      <div class="track svelte-1ivqid2jrt9dg" aria-hidden="true">
        <!>
      </div>
      <p class="counts svelte-1ivqid2jrt9dg">
        <span> </span>
        <span> </span>
        <!>
        <!>
      </p>
      <button type="button">
        End session
        <!>
      </button>
    </div>
  `,
		1
	),
	ReviewSession[$.FILENAME],
	[
		[111, 4],
		[151, 4, [[152, 6], [157, 6, [[158, 8], [159, 8]]], [163, 6]]]
	]
);

var root_9 = $.add_locations(
	$.from_html(
		`
    <!>
  `,
		1
	),
	ReviewSession[$.FILENAME],
	[]
);

var root_10 = $.add_locations(
	$.from_html(
		`

<div>
  <!>
</div>

`,
		1
	),
	ReviewSession[$.FILENAME],
	[[109, 0]]
);

export default function ReviewSession($$anchor, $$props) {
	$.check_target(new.target);
	$.push($$props, true, ReviewSession);

	let busy = $.prop($$props, 'busy', 3, false);
	let hints = $.tag($.state(false), 'hints');
	let pressed = $.tag($.state(null), 'pressed');
	let more = $.tag($.state(void 0), 'more');
	const press = new Press();
	const step = $.tag($.derived(() => phase($$props.session)), 'step');
	const card = $.tag($.derived(() => $$props.session.turn?.card), 'card');
	const count = $.tag($.derived(() => tally($$props.session)), 'count');
	const bar = $.tag($.derived(() => segments($$props.session)), 'bar');
	const held = $.tag($.derived(() => locked($$props.session) || busy()), 'held');
	const ready = $.tag($.derived(() => canResume($$props.session, $$props.now) && !busy()), 'ready');

	$.user_effect(() => watchAlt((h) => $.set(hints, h, true)));

	$.user_effect(() => {
		$.get(step);
		press.cancel();
		$.set(pressed, null);
	});

	$.user_effect(() => {
		if ($.strict_equals($.get(step), "waiting")) $.get(more)?.focus();
	});

	function run(action) {
		if ($.strict_equals(action, "back")) $$props.onback(); else if ($.strict_equals(action, "resume")) $.get(ready) && $$props.onresume(); else if (!$.get(held)) $$props.onend();
	}

	const END_KEY = "KeyE";

	// Keys are identified by e.key, except Alt+E by its code: on macOS Alt+E types a dead key, not "e".
	const keyOf = (e) => $.strict_equals(e.code, END_KEY) ? END_KEY : e.key;

	function actionFor(e) {
		if (e.metaKey || e.ctrlKey) return null;
		if (e.altKey) return $.strict_equals(e.code, END_KEY) && $.strict_equals($.get(step), "over", false) && !$.get(held) ? "end" : null;

		const activate = $.strict_equals(e.key, "Enter") || $.strict_equals(e.key, " ");

		if ($.strict_equals($.get(step), "over")) return activate || $.strict_equals(e.key, "Escape") ? "back" : null;
		if ($.strict_equals($.get(step), "waiting") && activate) return $.get(ready) ? "resume" : null;

		return null;
	}

	$.user_effect(() => {
		const cancel = () => {
			press.cancel();
			$.set(pressed, null);
		};

		const down = (e) => {
			// TODO: Scope shortcuts to this session; global Enter/Space also capture storybook controls.
			const action = actionFor(e);

			if (!action) return;

			e.preventDefault();

			if (press.down(keyOf(e), e.repeat, action)) $.set(pressed, action, true);
		};

		const up = (e) => {
			const action = press.up(keyOf(e));

			if (!action) return;

			e.preventDefault();
			$.set(pressed, null);
			run(action);
		};

		addEventListener("keydown", down);
		addEventListener("keyup", up);
		addEventListener("blur", cancel);

		return () => {
			removeEventListener("keydown", down);
			removeEventListener("keyup", up);
			removeEventListener("blur", cancel);
		};
	});

	var $$exports = { ...$.legacy_api() };

	$.next();

	var fragment = root_10();
	var div = $.sibling($.first_child(fragment));
	let classes;
	var node = $.sibling($.child(div));

	{
		var consequent_5 = ($$anchor) => {
			var fragment_1 = root_8();
			var div_1 = $.sibling($.first_child(fragment_1));
			var node_1 = $.sibling($.child(div_1));

			{
				var consequent = ($$anchor) => {
					var fragment_2 = root();
					var node_2 = $.sibling($.first_child(fragment_2));

					{
						let $0 = $.derived(() => shownResult($$props.session));
						let $1 = $.derived(() => saveView($$props.session));

						$.add_svelte_meta(
							() => Flashcard(node_2, {
								get card() {
									return $.get(card);
								},

								get result() {
									return $.get($0);
								},

								get save() {
									return $.get($1);
								},

								get busy() {
									return busy();
								},

								get onsubmit() {
									return $$props.onsubmit;
								},

								get oncontinue() {
									return $$props.onnext;
								},

								get onretry() {
									return $$props.onretry;
								},

								get hints() {
									return $.get(hints);
								}
							}),
							'component',
							ReviewSession,
							113,
							8,
							{ componentTag: 'Flashcard' }
						);
					}

					$.next();
					$.append($$anchor, fragment_2);
				};

				var alternate = ($$anchor) => {
					var fragment_3 = root_3();
					var section = $.sibling($.first_child(fragment_3));
					var h2 = $.sibling($.child(section));
					var text = $.only_child(h2);
					var ul = $.sibling(h2, 4);
					var node_3 = $.sibling($.child(ul));

					$.add_svelte_meta(
						() => $.each(node_3, 17, () => $.get(count).coming, (w) => w.card.id, ($$anchor, w) => {
							$.next();

							var fragment_4 = root_1();
							var li = $.sibling($.first_child(fragment_4));
							var span = $.sibling($.child(li));
							var text_1 = $.only_child(span, true);
							var span_1 = $.sibling(span, 2);
							var text_2 = $.only_child(span_1, true);
							var span_2 = $.sibling(span_1, 2);
							var text_3 = $.only_child(span_2, true);

							$.next();
							$.reset(li);
							$.next();

							$.template_effect(
								($0) => {
									$.set_text(text_1, $.get(w).card.word ?? $.get(w).card.prompt);
									$.set_text(text_2, KIND_TEXT[$.get(w).card.kind]);
									$.set_text(text_3, $0);
								},
								[() => backText($.get(w).at, $$props.now)]
							);

							$.append($$anchor, fragment_4);
						}),
						'each',
						ReviewSession,
						130,
						12
					);

					$.next();
					$.reset(ul);

					var button = $.sibling(ul, 2);
					let classes_1;
					var node_4 = $.sibling($.child(button));

					{
						var consequent_1 = ($$anchor) => {
							var kbd = root_2();

							$.append($$anchor, kbd);
						};

						$.add_svelte_meta(
							() => $.if(node_4, ($$render) => {
								if ($.get(hints)) $$render(consequent_1);
							}),
							'if',
							ReviewSession,
							146,
							12
						);
					}

					$.next();
					$.reset(button);
					$.bind_this(button, ($$value) => $.set(more, $$value), () => $.get(more));
					$.next();
					$.reset(section);
					$.next();

					$.template_effect(() => {
						$.set_text(text, `
            ${$.strict_equals($.get(count).coming.length, 1)
							? "1 card is"
							: `${$.get(count).coming.length} cards are`} coming back
          `);

						$.set_attribute(button, 'aria-disabled', $.get(ready) ? undefined : "true");
						classes_1 = $.set_class(button, 1, 'svelte-1ivqid2jrt9dg', null, classes_1, { pressed: $.strict_equals($.get(pressed), "resume") });
					});

					$.delegated('click', button, function click(e) {
						return $.strict_equals(e.detail, 0, false) && run("resume");
					});

					$.append($$anchor, fragment_3);
				};

				$.add_svelte_meta(
					() => $.if(node_1, ($$render) => {
						if ($.get(card) && $$props.session.turn) $$render(consequent); else $$render(alternate, -1);
					}),
					'if',
					ReviewSession,
					112,
					6
				);
			}

			$.next();
			$.reset(div_1);

			var div_2 = $.sibling(div_1, 2);
			var div_3 = $.sibling($.child(div_2));
			var node_5 = $.sibling($.child(div_3));

			$.add_svelte_meta(
				() => $.each(node_5, 17, () => $.get(bar), $.index, ($$anchor, segment) => {
					$.next();

					var fragment_5 = root_4();
					var span_3 = $.sibling($.first_child(fragment_5));

					$.next();
					$.template_effect(() => $.set_class(span_3, 1, $.clsx($.get(segment)), 'svelte-1ivqid2jrt9dg'));
					$.append($$anchor, fragment_5);
				}),
				'each',
				ReviewSession,
				153,
				8
			);

			$.next();
			$.reset(div_3);

			var p = $.sibling(div_3, 2);
			var span_4 = $.sibling($.child(p));
			var text_4 = $.only_child(span_4);
			var span_5 = $.sibling(span_4, 2);
			var text_5 = $.only_child(span_5);
			var node_6 = $.sibling(span_5, 2);

			{
				var consequent_2 = ($$anchor) => {
					var span_6 = root_5();
					var text_6 = $.only_child(span_6);

					$.template_effect(() => $.set_text(text_6, `${$.get(count).coming.length ?? ''} coming back`));
					$.append($$anchor, span_6);
				};

				$.add_svelte_meta(
					() => $.if(node_6, ($$render) => {
						if ($.get(count).coming.length) $$render(consequent_2);
					}),
					'if',
					ReviewSession,
					160,
					8
				);
			}

			var node_7 = $.sibling(node_6, 2);

			{
				var consequent_3 = ($$anchor) => {
					var span_7 = root_6();

					$.append($$anchor, span_7);
				};

				$.add_svelte_meta(
					() => $.if(node_7, ($$render) => {
						if ($.strict_equals($.get(card)?.state, "new") && $.strict_equals($.get(step), "waiting", false)) $$render(consequent_3);
					}),
					'if',
					ReviewSession,
					161,
					8
				);
			}

			$.next();
			$.reset(p);

			var button_1 = $.sibling(p, 2);
			let classes_2;
			var node_8 = $.sibling($.child(button_1));

			{
				var consequent_4 = ($$anchor) => {
					var kbd_1 = root_7();

					$.append($$anchor, kbd_1);
				};

				$.add_svelte_meta(
					() => $.if(node_8, ($$render) => {
						if ($.get(hints)) $$render(consequent_4);
					}),
					'if',
					ReviewSession,
					171,
					8
				);
			}

			$.next();
			$.reset(button_1);
			$.next();
			$.reset(div_2);
			$.next();

			$.template_effect(() => {
				$.set_text(text_4, `${$.get(count).done ?? ''} done`);
				$.set_text(text_5, `${$.get(count).correct ?? ''} correct`);
				classes_2 = $.set_class(button_1, 1, 'end svelte-1ivqid2jrt9dg', null, classes_2, { pressed: $.strict_equals($.get(pressed), "end") });
				$.set_attribute(button_1, 'aria-disabled', $.get(held) ? "true" : undefined);
			});

			$.delegated('click', button_1, function click_1(e) {
				return $.strict_equals(e.detail, 0, false) && run("end");
			});

			$.append($$anchor, fragment_1);
		};

		var alternate_1 = ($$anchor) => {
			var fragment_6 = root_9();
			var node_9 = $.sibling($.first_child(fragment_6));

			{
				let $0 = $.derived(() => summary($$props.session, $$props.now));
				let $1 = $.derived(() => $.strict_equals($.get(pressed), "back"));

				$.add_svelte_meta(
					() => SessionSummary(node_9, {
						get summary() {
							return $.get($0);
						},

						get hints() {
							return $.get(hints);
						},

						get pressed() {
							return $.get($1);
						},

						get onback() {
							return $$props.onback;
						}
					}),
					'component',
					ReviewSession,
					175,
					4,
					{ componentTag: 'SessionSummary' }
				);
			}

			$.next();
			$.append($$anchor, fragment_6);
		};

		$.add_svelte_meta(
			() => $.if(node, ($$render) => {
				if ($.strict_equals($.get(step), "over", false)) $$render(consequent_5); else $$render(alternate_1, -1);
			}),
			'if',
			ReviewSession,
			110,
			2
		);
	}

	$.next();
	$.reset(div);
	$.next();
	$.template_effect(() => classes = $.set_class(div, 1, 'session svelte-1ivqid2jrt9dg', null, classes, { reviewing: $.strict_equals($.get(step), "over", false) }));
	$.append($$anchor, fragment);

	return $.pop($$exports);
}

$.delegate(['click']);
import "bun-svelte:ReviewSession.svelte-3cf6r00mmrw2z-style.css";